import { z } from 'zod';

export const ViewerConnection = z.enum(['self', 'matched', 'liked', 'none']);
export type ViewerConnection = z.infer<typeof ViewerConnection>;

export const GroupPhotoTagUserDto = z.object({
  id: z.uuid(),
  displayName: z.string(),
  avatarUrl: z.string().nullable(),
  username: z.string().nullable(),
});
export type GroupPhotoTagUserDto = z.infer<typeof GroupPhotoTagUserDto>;

export const GroupPhotoTagDto = z.object({
  id: z.uuid(),
  userId: z.uuid(),
  xPercent: z.number(),
  yPercent: z.number(),
  user: GroupPhotoTagUserDto,
  viewerConnection: ViewerConnection,
});
export type GroupPhotoTagDto = z.infer<typeof GroupPhotoTagDto>;

export const GroupPhotoDto = z.object({
  id: z.uuid(),
  eventId: z.uuid(),
  url: z.string(),
  width: z.number().nullable(),
  height: z.number().nullable(),
  createdAt: z.iso.datetime(),
  tags: z.array(GroupPhotoTagDto),
});
export type GroupPhotoDto = z.infer<typeof GroupPhotoDto>;
